import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { EmperorCardTypes } from '@boldpenguin/emperor-presentational';
import { BpSdkStore } from '@boldpenguin/sdk';
import { environment } from '@environments/environment';
import { Store, select } from '@ngrx/store';
import { LocalStorageService } from 'ngx-webstorage';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { BpSdkCoreService } from 'src/app/core/services/bp-sdk-core-service/bp-sdk-core.service';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import {
  MixpanelEventType,
  MixpanelService,
} from 'src/app/core/services/mixpanel-service/mixpanel.service';
import { selectRedirectPath } from 'src/app/core/store/redirect/redirect.selectors';
import { compatibilityBannerLocalStorage } from 'src/app/shared/components/compatibility-banner/compatibility-banner.component';
import { getRedirectUri } from '../../utilities/redirect-utilities';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.scss'],
})
export class SamlLoginComponent implements OnInit {
  @Input() customSubdomain = '';

  readonly EmperorCardTypes = EmperorCardTypes;
  bpSdkStoreState: BpSdkStore;

  constructor(
    private localSt: LocalStorageService,
    private bpSdkCoreService: BpSdkCoreService,
    private bpSdkStoreService: BpSdkStoreService,
    private store: Store,
    private mixpanel: MixpanelService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.mixpanel.track(MixpanelEventType.SAML_LOADED);

    this.bpSdkStoreService.state$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => {
        this.bpSdkStoreState = state;
      });
  }

  gotoSamlAuth() {
    this.mixpanel.track(MixpanelEventType.SAML_SUBMITTED);

    if (!!this.bpSdkStoreState) {
      this.store
        .pipe(select(selectRedirectPath))
        .pipe(
          distinctUntilChanged(),
          take(1),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe((redirectPath) => {
          this.bpSdkCoreService.login(
            {
              ...this.bpSdkStoreState.config,
              authUri: environment.apiAuthUri,
              callbackUri: getRedirectUri(redirectPath),
            },
            {
              login_hint: `user@${this.customSubdomain}.com`,
            },
          );

          this.localSt.clear(compatibilityBannerLocalStorage);
        });
    }
  }
}
